import { render, staticRenderFns } from "./DetalleAuto.vue?vue&type=template&id=80fe2e80&"
import script from "./DetalleAuto.vue?vue&type=script&lang=ts&"
export * from "./DetalleAuto.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleAuto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports